import { Spinner } from 'components/spinner';
import dynamic from 'next/dynamic';
import styles from './IppicaNewsModalBody.module.scss';

export type IppicaNewsModalBodyProps = {
  title?: string;
  content?: string;
  handleClose: () => void;
  isLoading: boolean;
};

export const DynamicIppicaNewsModalBody = dynamic(() =>
  import('features/ippica/components/ippicaNewsModal/components/ippicaNewsModalBody').then(
    (mod) => mod.IppicaNewsModalBody
  )
);
export const IppicaNewsModalBody = ({ title, content, handleClose, isLoading }: IppicaNewsModalBodyProps) => {
  return (
    <div className={`${styles.container} ${isLoading ? styles.loading : ''}`}>
      <h3 className={styles.title}>{title}</h3>
      {isLoading ? (
        <Spinner className={styles.spinner} />
      ) : (
        content && <div dangerouslySetInnerHTML={{ __html: content }} suppressHydrationWarning />
      )}
    </div>
  );
};
